// Core imports
import * as React from 'react';

// Models imports
import TrackingModel from 'src/model/trackingInfo.model';

// Style and misc imports
import './TrackingToolBar.scss';

interface ITrackingToolBarProps {
  t: any;
  filterSelected: boolean;
  onClearClicked(): void;
}

class TrackingToolBar extends React.Component<ITrackingToolBarProps, any> {
  private getClearButton = () => {
    const { filterSelected, onClearClicked } = this.props;
    if (filterSelected) {
      return (
        <i
          className="rpds-close rp-tracking--toolbar--clear-icon"
          onClick={() => {
            onClearClicked();
          }}
        />
      );
    } else {
      return <React.Fragment />;
    }
  };

  private getClearSection = (t: any) => {
    const { filterSelected } = this.props;
    if (filterSelected) {
      return (
        <div
          className="rp-tracking--toolbar--text"
          onClick={() => {
            this.props.onClearClicked();
          }}
        >
          <span className="clear-selection">{t('common.clearFilters')}</span>
        </div>
      );
    } else {
      return <React.Fragment />;
    }
  };

  public render() {
    const { t, filterSelected } = this.props;
    return (
      <div
        className={
          filterSelected
            ? 'rp-tracking--toolbar--clear'
            : 'rp-tracking--toolbar--hidden'
        }
      >
        {this.getClearButton()}
        {this.getClearSection(t)}
      </div>
    );
  }
}

export default TrackingToolBar;
